import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  Alert,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const VerifyEmailSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Container component="main" maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            padding: 4,
            backgroundColor: '#ffffff',
          }}
        >
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <CheckCircleIcon sx={{ fontSize: 60, color: '#4caf50', mb: 2 }} />
            <Typography
              component="h1"
              variant="h4"
              sx={{
                fontWeight: 'bold',
                color: '#000000',
                marginBottom: 2,
              }}
            >
              이메일 인증 완료
            </Typography>
          </Box>

          <Alert severity="success" sx={{ mb: 3 }}>
            {email ? (
              <>
                <strong>{email}</strong> 이메일 인증이 완료되었습니다.
              </>
            ) : (
              <>이메일 인증이 완료되었습니다.</>
            )}
          </Alert>

          <Typography
            variant="body1"
            sx={{
              color: '#666666',
              marginBottom: 3,
              textAlign: 'center',
            }}
          >
            이제 로그인하여 서비스를 이용하실 수 있습니다.
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <Button
              variant="contained"
              onClick={() => navigate('/login')}
              sx={{
                backgroundColor: '#000000',
                color: '#ffffff',
                '&:hover': {
                  backgroundColor: '#333333',
                },
                px: 4,
              }}
            >
              로그인하기
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default VerifyEmailSuccess;

